<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head" height="null">
        <div class="head-info">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item :label="$t('commonInfo.status') + ':'">
              <el-select
                v-model="page_status"
                clearable
                :placeholder="$t('statusMsg')"
                :loading-text="$t('loading')"
              >
                <el-option
                  v-for="item in $t('commonStatusList')"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('commonInfo.keyWord')+':'">
              <el-input
                v-model="search_key"
                clearable
                size="medium"
                :placeholder="$t('commonInfo.pleaseEnterKey')"
                @keyup.enter.native="getAuthUserList"
              ></el-input>
            </el-form-item>
            <el-button
              class="top-button"
              size="medium"
              type="primary"
              round
              @click="getAuthUserList"
            >{{$t('commonInfo.filter')}}</el-button>
            <el-button
              class="top-button"
              size="medium"
              type="primary"
              round
              @click="newModelOnClick"
            >{{$t('commonInfo.add')}}</el-button>
          </el-form>
        </div>
      </el-header>
      <el-main>
        <el-table
          :data="auth_user_list"
          style="width: 100%"
          :cell-style="$common.tableStyle"
          :header-cell-style="$common.tableStyle"
          border
          default-expand-all
        >
          <el-table-column label="#" width="80">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.$index + 1 }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('admin.name')">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.row.name }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('admin.remark')">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.row.remark }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('admin.email')">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.row.email }}</p>
            </template>
          </el-table-column>
          <!-- <el-table-column label="最后修改时间">
            <template slot-scope="scope">
              <p style="font-weight: bold">
                {{ $common.formatTimesToTime(scope.row.updated_at) }}
              </p>
            </template>
          </el-table-column>-->
          <el-table-column :label="$t('weight')" width="160">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.row.number }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('status')" width="120">
            <template slot-scope="scope">
              <el-tag
                style="font-weight: bold"
                :type="$t('commonStatusList')[scope.row.status].tag"
                effect="dark"
              >{{ $t('commonStatusList')[scope.row.status].name }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column :label="$t('operate')" width="140">
            <template slot-scope="scope">
              <el-button
                style="color: #03aef9"
                @click="sysModelOnclick(scope.row)"
                type="text"
              >{{$t('admin.refreshAuth')}}</el-button>
            </template>
          </el-table-column>
          <el-table-column :label="$t('operate')" width="140">
            <template slot-scope="scope">
              <el-button
                style="color: #03aef9"
                @click="editModelOnclick(scope.row)"
                type="text"
              >{{$t('edit')}}</el-button>
              <el-button
                style="color: #f03c69"
                @click="removeModelOnclick(scope.row)"
                type="text"
              >{{$t('delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer class="footer-info">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :page-size="page_size"
          :pager-count="9"
          :total="page_total"
          :current-page="page_number"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "AdminListView",
  data() {
    return {
      loading: false,
      search_key: "",
      page_status: 0,
      page_total: 0,
      page_size: 15,
      page_number: 1,
      auth_user_list: []
    };
  },
  created() {
    this.getAuthUserList();
  },
  methods: {
    handleCurrentChange(val) {
      this.page_number = val;
      this.getAuthUserList();
    },
    getAuthUserList() {
      let _me = this;
      let params = {
        key: _me.search_key,
        status: _me.page_status,
        page_size: _me.page_size,
        page_number: _me.page_number,
        sort_fields: ""
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/admin/root/user/find/list", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.auth_user_list =
              res.data.array === undefined ? [] : res.data.array;
            _me.page_total = res.data.total;
          } else {
            _me.$message({
              message: res.message || _me.$t("errorMsg"),
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || _me.$t("errorMsg"),
            type: "error"
          });
        });
    },
    newModelOnClick() {
      this.$router.push("admin-detail");
    },
    sysModelOnclick(model) {
      let _me = this;
      let params = {
        user_id: model.user_id
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/admin/root/user/auth/sync/id", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.$message.success(_me.$t("admin.updatePermissions"));
          } else {
            _me.$message({
              message: res.message || _me.$t("errorMsg"),
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || _me.$t("errorMsg"),
            type: "error"
          });
        });
    },
    editModelOnclick(model) {
      this.$router.push("admin-detail?id=" + model.id);
    },
    removeModelOnclick(model) {
      let _me = this;
      _me
        .$confirm(_me.$t("confirm.title"), _me.$t("confirm.tip"), {
          confirmButtonText: _me.$t("confirm.determine"),
          cancelButtonText: _me.$t("confirm.cancel"),
          type: "warning"
        })
        .then(() => {
          _me.removeItem(model);
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log(_me.$t("cancelDelete"));
        });
    },
    removeItem(model) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: model.id
      };
      _me.$common
        .httpPost("/api/admin/root/user/delete", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.$message.success(_me.$t("successfullyDeleted"));
            _me.getAuthUserList();
          } else {
            _me.$message({
              message: res.message || _me.$t("errorMsg"),
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || _me.$t("errorMsg"),
            type: "error"
          });
        });
    }
  }
};
</script>

<style scoped></style>
